export enum CutOffTimeEnum {
    Sameday = 0,
    Drawdown = 1
}
